import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ChangeMentorModel } from 'common/models/page-models/mentor/change-mentor-model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { ChangeMentorFormWidgetService } from 'common/widget/mentor/change-mentor-widget.service';

@Injectable({
    providedIn: 'root'
})
export class ChangeMentorFormResolver extends FormResolverService<ChangeMentorModel> {
    constructor(
        protected fs: ChangeMentorFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    // override modifyResponseData(dataModel: any, meta: any, widget: any) {
    //     // dataModel['student_ids']=dataModel.student_id;
    //     // dataModel['branch_id'] = null;
    //     // dataModel['group_id'] = null;
    //     // dataModel['batch_id'] = null;
    //     console.log(dataModel);
    //     return dataModel;
    // }
}
